import { Wrapper } from './ui';
import styled from 'styled-components';
import { useVehicleEditing } from 'context/isAnotherUserEditingContext';

const CONCURRENT_BG = '#E93323';

const InnerWrapper = styled.div`
  display: flex;
  flex-direction: column;
  gap: 4px;
`;

export const ConcurrentEditBanner = () => {
  const { hasAnotherEditor, warningText } = useVehicleEditing();
  if (!hasAnotherEditor) return null;

  return (
    <Wrapper bg={CONCURRENT_BG}>
      <InnerWrapper>
        <span style={{ fontWeight: '500' }}>Warning!!!</span>
        <span>{warningText!}</span>
      </InnerWrapper>
    </Wrapper>
  );
};
